import { FC, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LinkCard } from "@/components/LinkCard";
import { Clock } from "lucide-react";

export const RecentLinks: FC = () => {
  const [links, setLinks] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRecentLinks = async () => {
      const { data, error } = await supabase
        .from("marketplace_links")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(5);

      if (!error && data) {
        setLinks(data);
      }
      setIsLoading(false);
    };

    fetchRecentLinks();

    // Subscribe to real-time changes
    const channel = supabase
      .channel('schema-db-changes')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'marketplace_links'
        },
        (payload) => {
          setLinks(currentLinks => {
            const newLink = payload.new;
            const updatedLinks = [newLink, ...currentLinks].slice(0, 5);
            return updatedLinks;
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  if (isLoading) return null;
  if (links.length === 0) return null;

  return (
    <section className="py-6 container mx-auto px-4">
      <div className="flex items-center justify-center space-x-2 mb-3">
        <Clock className="w-4 h-4 text-green-500" />
        <h2 className="text-lg font-bold bg-gradient-to-r from-green-600 to-green-400 bg-clip-text text-transparent">
          Link Terbaru
        </h2>
        <Clock className="w-4 h-4 text-green-500" />
      </div>
      <div className="grid gap-3 max-w-xl mx-auto">
        {links.map((link, index) => (
          <div
            key={link.id}
            className="animate-fade-up"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <LinkCard
              title={link.title}
              url={link.url}
              whatsapp_number={link.whatsapp_number}
              message_template={link.message_template}
              description={link.description}
            />
          </div>
        ))}
      </div>
    </section>
  );
};